import { c as _c } from "react/compiler-runtime";
const RATES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
interface VideoSpeedControlProps {
  onChange: (rate: number) => void;
  value: number;
}
export default function VideoSpeedControl(t0) {
  const $ = _c(6);
  const {
    onChange,
    value
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = e => onChange(Number(e.target.value));
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = RATES.map(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== value) {
    t3 = <select aria-label="Playback speed" className="h-6.5 shrink-0 cursor-pointer appearance-none rounded-lg bg-transparent px-1.5 text-center font-[450] font-sans text-white text-xs tabular-nums transition-colors duration-200 ease-out hover:bg-white/15" onChange={t1} value={value}>{t2}</select>;
    $[3] = t1;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(rate) {
  return <option key={rate} value={rate}>{rate}×</option>;
}